// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1AZs1","label":"SetPasswdForm_label__cE4lq"};